var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2110_2432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.509876 11.8563C0.509318 13.8728 1.0362 15.8417 2.03806 17.5771L0.414062 23.5066L6.48216 21.9156C8.16052 22.8292 10.041 23.308 11.9519 23.3081H11.9569C18.2653 23.3081 23.4005 18.1748 23.4032 11.8653C23.4044 8.80792 22.2148 5.93295 20.0535 3.76997C17.8926 1.60718 15.0186 0.415458 11.9565 0.414062C5.64737 0.414062 0.512574 5.54709 0.509969 11.8563",
    fill: "url(#paint0_linear_2110_2432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0995349 11.8527C0.0988837 13.9417 0.644651 15.981 1.68223 17.7786L0 23.9207L6.28567 22.2726C8.01758 23.2168 9.96754 23.7147 11.9517 23.7154H11.9568C18.4915 23.7154 23.8112 18.3975 23.814 11.8621C23.8151 8.69488 22.5827 5.71656 20.3442 3.47609C18.1054 1.23591 15.1287 0.00130233 11.9568 0C5.42102 0 0.10214 5.31721 0.0995349 11.8527ZM3.84288 17.469L3.60819 17.0965C2.62158 15.5277 2.10084 13.7149 2.10158 11.8534C2.10363 6.4213 6.52447 2.00186 11.9606 2.00186C14.5931 2.00298 17.0672 3.02921 18.928 4.89116C20.7887 6.7533 21.8127 9.22865 21.812 11.8614C21.8096 17.2935 17.3887 21.7135 11.9568 21.7135H11.9529C10.1843 21.7126 8.44967 21.2376 6.93693 20.34L6.57693 20.1265L2.84688 21.1045L3.84288 17.469Z",
    fill: "url(#paint1_linear_2110_2432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99108 6.89771C8.76913 6.4044 8.53555 6.39445 8.32448 6.3858C8.15164 6.37836 7.95406 6.37892 7.75666 6.37892C7.55908 6.37892 7.23806 6.45324 6.96671 6.74952C6.69508 7.04608 5.92969 7.76273 5.92969 9.22031C5.92969 10.6779 6.99136 12.0866 7.13936 12.2845C7.28755 12.482 9.18894 15.5689 12.2003 16.7564C14.703 17.7433 15.2123 17.547 15.7555 17.4975C16.2987 17.4482 17.5084 16.7811 17.7552 16.0892C18.0022 15.3975 18.0022 14.8046 17.9281 14.6807C17.8541 14.5572 17.6565 14.4831 17.3602 14.335C17.0639 14.1869 15.6073 13.4701 15.3357 13.3712C15.0641 13.2724 14.8666 13.2231 14.669 13.5198C14.4715 13.8159 13.9041 14.4831 13.7312 14.6807C13.5584 14.8787 13.3855 14.9034 13.0893 14.7552C12.7928 14.6065 11.8387 14.2941 10.7067 13.2849C9.82597 12.4996 9.23136 11.5298 9.05852 11.2331C8.88569 10.937 9.04001 10.7764 9.18857 10.6288C9.32169 10.496 9.48494 10.2828 9.63322 10.1099C9.78094 9.93687 9.83025 9.81343 9.92904 9.61585C10.0279 9.41808 9.97843 9.24506 9.90448 9.09687C9.83025 8.94868 9.25452 7.48347 8.99108 6.89771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2110_2432",
    x1: 1149.87,
    y1: 2309.67,
    x2: 1149.87,
    y2: 0.414062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2110_2432",
    x1: 1190.7,
    y1: 2392.07,
    x2: 1190.7,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2110_2432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.814,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.4b3ea82ed9fe36a3ca447eeb497e25dd.svg";
export { ForwardRef as ReactComponent };